import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { usePostBodyWithJwtMutation } from 'src/redux/api/cabinet';
import { iLogout } from 'src/redux/slices/app';
import { Alerting } from 'src/views/components_cabinet/Alerting';
import { P2pBookingTable } from './P2pBookingTable';

export const P2pBroniPage = () => {
    const [items, setItems] = useState<{ data: any[], current_page: number, last_page: number }>({ data: [], current_page: 1, last_page: 1 });
    const dispatch = useDispatch();
    const [getAlert, setAlert] = useState<{ type: number; msg: string } | undefined>(undefined);
    const [reload, setReload] = useState<boolean>(false);
    const [getData, { isLoading }] = usePostBodyWithJwtMutation();

    const getDataFunction = async (data: any = [], route = 'p2p-bron') => {
        const jwt = localStorage.getItem('jwt');

        try {
            const payload = await getData({
                body: data,
                route,
                jwt,
            }).unwrap();
            setItems(payload.data)

        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setAlert({ type: 2, msg: error.data?.message });
        }
    }

    const updateReload = () => {
        setReload(!reload);
    }

    useEffect(() => {
        getDataFunction();
    }, [reload]);

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            <Card>
                <CardContent>
                    <Typography variant='h6' mb={3}>
                        Забронированные вами
                    </Typography>
                    <Box pb={4} minHeight={360}>
                        {isLoading ?
                            <Box minHeight={400} display='flex' alignItems='center' justifyContent='center'>
                                <CircularProgress />
                            </Box>
                            : items?.data.length == 0 ?
                                <Box minHeight={360} display='flex' alignItems='center' justifyContent='center'>
                                    <Typography textAlign='center' variant='h4'>
                                        Броней нет
                                    </Typography>
                                </Box> :
                                <P2pBookingTable data={items} updateReload={updateReload} />
                        }

                    </Box>
                </CardContent>
            </Card>
        </>
    )
}
